module.exports = __webpack_public_path__ + "static/media/2.32471614.jpg";